import AutoSubmit from "@stimulus-components/auto-submit"

export class Controller extends AutoSubmit {}
